import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';
import { requestPasswordReset } from '../../services/authService';
import { extractErrorMessage } from '../../utils/errors';
import { AuthField, AuthLayout, FormError, SubmitButton, authLinkSx } from './AuthLayout';
import { MUTED_TEXT_COLOR } from '../../styles/tokens';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting) return;
    setError('');
    setSubmitting(true);
    try {
      setMessage(await requestPasswordReset(email.trim()));
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Восстановление пароля" onSubmit={handleSubmit}>
      {message ? (
        <Typography role="status" sx={{ fontSize: '15px', color: '#fff' }}>
          {message}
        </Typography>
      ) : (
        <>
          <Typography sx={{ fontSize: '14px', color: MUTED_TEXT_COLOR }}>
            Укажите email — отправим ссылку для установки нового пароля.
          </Typography>
          <AuthField
            id="forgot-email"
            label="Email"
            type="email"
            inputMode="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="email"
            required
          />
          <FormError>{error}</FormError>
          <SubmitButton submitting={submitting}>Отправить ссылку</SubmitButton>
        </>
      )}
      <Box sx={{ textAlign: 'center', fontSize: '14px' }}>
        <Link component={RouterLink} to="/login" sx={authLinkSx}>
          Вернуться ко входу
        </Link>
      </Box>
    </AuthLayout>
  );
}
